import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuthStore } from '../hooks/useAuthStore'
import { useUser } from '../hooks/useQueries/useUsers'

export const PrivateRoute = () => {
  const { idToken, userId } = useAuthStore()
  const { pathname } = useLocation()
  const { data: user, isLoading } = useUser(userId!, !!idToken)

  if (!idToken) {
    return <Navigate to='/sign-in' replace />
  }

  if (isLoading) {
    return null
  }

  if ((!user?.name || !user?.lastName) && pathname !== '/complete-profile') {
    return <Navigate to='/complete-profile' replace />
  }

  if (pathname === '/complete-profile' && user?.name && user?.lastName) {
    return <Navigate to='/companies' replace />
  }

  return <Outlet />
}
